import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatSelectionCardGroup = createCustomElementWrapper('kat-selection-card-group', 'KatSelectionCardGroup', {}, {
    'onChange': 'change',
});
